export const RIGHT_DRAWER_WIDTH = 560;
